// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/eval.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.EvalDataset
 */
export const EvalDataset = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalDataset",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "row_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "frozen_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.EvalDatasetRow
 */
export const EvalDatasetRow = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalDatasetRow",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "parsed_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "parsed_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "expected_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "expected_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "expected_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "expected_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 14, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.EvalRun
 */
export const EvalRun = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalRun",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pipeline_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "algorithm_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "config_snapshot", kind: "message", T: Struct },
    { no: 7, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "match_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "metrics", kind: "message", T: EvalMetrics },
    { no: 11, name: "started_at", kind: "message", T: Timestamp },
    { no: 12, name: "completed_at", kind: "message", T: Timestamp },
    { no: 13, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "created_at", kind: "message", T: Timestamp },
    { no: 15, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "dataset_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.EvalRunRow
 */
export const EvalRunRow = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalRunRow",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "eval_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dataset_row_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "expected_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "expected_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "actual_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "actual_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "match_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "rewritten_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "rank_of_correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "candidates", kind: "message", T: EvalCandidate, repeated: true },
    { no: 14, name: "expected_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "actual_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "unit_correct", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "expected_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 18, name: "actual_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 19, name: "is_correct", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.EvalCandidate
 */
export const EvalCandidate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalCandidate",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "similarity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "rank", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.EvalMetrics
 */
export const EvalMetrics = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalMetrics",
  () => [
    { no: 1, name: "precision_at_1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "precision_at_3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "precision_at_5", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "recall_at_1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "recall_at_3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "recall_at_5", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "mrr", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "ndcg_at_5", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "ndcg_at_10", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "hit_at_1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 11, name: "hit_at_3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "hit_at_5", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "hit_at_10", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "unit_conversion_accuracy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "triage_breakdown", kind: "message", T: TriageBreakdown, repeated: true },
    { no: 16, name: "total_rows", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.TriageBreakdown
 */
export const TriageBreakdown = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TriageBreakdown",
  () => [
    { no: 1, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "correct", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "accuracy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.EvalRunComparison
 */
export const EvalRunComparison = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalRunComparison",
  () => [
    { no: 1, name: "base_run", kind: "message", T: EvalRun },
    { no: 2, name: "compare_run", kind: "message", T: EvalRun },
    { no: 3, name: "base_metrics", kind: "message", T: EvalMetrics },
    { no: 4, name: "compare_metrics", kind: "message", T: EvalMetrics },
    { no: 5, name: "regressions", kind: "message", T: EvalRunRowDiff, repeated: true },
    { no: 6, name: "improvements", kind: "message", T: EvalRunRowDiff, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.EvalRunRowDiff
 */
export const EvalRunRowDiff = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EvalRunRowDiff",
  () => [
    { no: 1, name: "dataset_row_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_row", kind: "message", T: EvalRunRow },
    { no: 4, name: "compare_row", kind: "message", T: EvalRunRow },
  ],
);

/**
 * @generated from message omnios.v1.CreateEvalDatasetRequest
 */
export const CreateEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateEvalDatasetRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEvalDatasetRequest
 */
export const GetEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEvalDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalDatasetsRequest
 */
export const ListEvalDatasetsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalDatasetsRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalDatasetsResponse
 */
export const ListEvalDatasetsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalDatasetsResponse",
  () => [
    { no: 1, name: "datasets", kind: "message", T: EvalDataset, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.FreezeEvalDatasetRequest
 */
export const FreezeEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FreezeEvalDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.NewVersionEvalDatasetRequest
 */
export const NewVersionEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.NewVersionEvalDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteEvalDatasetRequest
 */
export const DeleteEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteEvalDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AddEvalDatasetRowsRequest
 */
export const AddEvalDatasetRowsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddEvalDatasetRowsRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rows", kind: "message", T: EvalDatasetRow, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AddEvalDatasetRowsResponse
 */
export const AddEvalDatasetRowsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddEvalDatasetRowsResponse",
  () => [
    { no: 1, name: "row_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ImportEvalDatasetRequest
 */
export const ImportEvalDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportEvalDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 3, name: "pipeline_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
  ],
);

/**
 * @generated from message omnios.v1.ImportEvalDatasetResponse
 */
export const ImportEvalDatasetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImportEvalDatasetResponse",
  () => [
    { no: 1, name: "imported_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalDatasetRowsRequest
 */
export const ListEvalDatasetRowsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalDatasetRowsRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalDatasetRowsResponse
 */
export const ListEvalDatasetRowsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalDatasetRowsResponse",
  () => [
    { no: 1, name: "rows", kind: "message", T: EvalDatasetRow, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateEvalDatasetRowRequest
 */
export const UpdateEvalDatasetRowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateEvalDatasetRowRequest",
  () => [
    { no: 1, name: "row_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expected_product_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "expected_product_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "expected_unit", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "expected_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteEvalDatasetRowsRequest
 */
export const DeleteEvalDatasetRowsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteEvalDatasetRowsRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "row_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.StartEvalRunRequest
 */
export const StartEvalRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartEvalRunRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "algorithm_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "match_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "config_override", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetEvalRunRequest
 */
export const GetEvalRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEvalRunRequest",
  () => [
    { no: 1, name: "eval_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalRunsRequest
 */
export const ListEvalRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalRunsRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalRunsResponse
 */
export const ListEvalRunsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalRunsResponse",
  () => [
    { no: 1, name: "runs", kind: "message", T: EvalRun, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalRunRowsRequest
 */
export const ListEvalRunRowsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalRunRowsRequest",
  () => [
    { no: 1, name: "eval_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "verdict_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEvalRunRowsResponse
 */
export const ListEvalRunRowsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEvalRunRowsResponse",
  () => [
    { no: 1, name: "rows", kind: "message", T: EvalRunRow, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.CompareEvalRunsRequest
 */
export const CompareEvalRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompareEvalRunsRequest",
  () => [
    { no: 1, name: "base_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "compare_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GenerateSyntheticDatasetRequest
 */
export const GenerateSyntheticDatasetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateSyntheticDatasetRequest",
  () => [
    { no: 1, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "max_rows", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "include_unit_variations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "include_noisy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "include_vendor_codes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.GenerateSyntheticDatasetResponse
 */
export const GenerateSyntheticDatasetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateSyntheticDatasetResponse",
  () => [
    { no: 1, name: "generated_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.StartCrossWorkspaceEvalRunRequest
 */
export const StartCrossWorkspaceEvalRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartCrossWorkspaceEvalRunRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "algorithm_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "match_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "config_override", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ListAllEvalRunsRequest
 */
export const ListAllEvalRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllEvalRunsRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAllEvalRunsResponse
 */
export const ListAllEvalRunsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAllEvalRunsResponse",
  () => [
    { no: 1, name: "runs", kind: "message", T: EvalRun, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

